export default __webpack_public_path__ + "static/media/Logo_Trust_NEAS@3x.2b5c98d6.png";